import type { Hit } from 'instantsearch.js';

import React from 'react';
import { resourceIcons } from '@src/utils/search';
import { IoDocumentText } from 'react-icons/io5';
import HitLink, { HitUserAction } from './Hit.Link';
import * as styles from '../../../pages/search/search.module.css';
import HitTitle from './Hit.Title';

type HitProps = {
  hit: Hit;
};

function HitMe({ hit }: HitProps) {
  const iconProps = { color: 'hsla(var(--mmc-pink))', size: 30 };

  const Icon = resourceIcons[hit.doc_type];

  const page = hit.type === 'module';

  return (
    <div className={styles.hitContainer}>
      <div className={styles.titleHeader}>
        {Icon ? <Icon {...iconProps} /> : <IoDocumentText {...iconProps} />}
        <div>
          <HitTitle hit={hit} />
          {hit?.doc_exam_course && (
            <div style={{ color: '#a8a8a8' }}>{hit.doc_exam_course.map((c) => c).join(', ')}</div>
          )}
        </div>
      </div>
      <div className={`${styles.hitActions} category-option-info`}>
        <HitUserAction page={page} hit={hit} />
      </div>
      <div className={styles.details}>
        <div>{page ? `Page (${hit.doc_type})` : hit.doc_type}</div>

        <div className={styles.hitWrapper}>
          <HitLink page={page} hit={hit} />
        </div>
        {/* <pre>{JSON.stringify(hit, null, 2)}</pre> */}
      </div>
    </div>
  );
}

export default HitMe;
